// export const RiskFilterStatuses = [
//   {
//     id: 'Select All',
//     value: 'Select All',
//     checked: false,
//     color: '#ffffff',
//   },
//   {
//     id: 'Short Date Urgent',
//     value: 'Short Date Urgent',
//     checked: false,
//     color: 'rgba(255, 105, 91, 0.4)',
//   },
//   {
//     id: 'Short Date Alert',
//     value: 'Short Date Alert',
//     checked: false,
//     color: 'rgba(255, 194, 85, 0.4)',
//   },
//   {
//     id: 'Out Of Stock',
//     value: 'Out Of Stock',
//     checked: false,
//     color: 'rgba(255, 105, 119, 0.4)',
//   },
//   {
//     id: 'Dead Stock',
//     value: 'Dead Stock',
//     checked: false,
//     color: 'rgba(74, 202, 255, 0.4)',
//   },
//   {
//     id: 'Over Stock Alert',
//     value: 'Over Stock Alert',
//     checked: false,
//     color: 'rgba(91, 214, 69, 0.4)',
//   },
//   {
//     id: 'Past Best Before Date',
//     value: 'Past Best Before Date',
//     checked: false,
//     color: 'rgba(83, 64, 255, 0.4)',
//   },
//   {
//     id: 'Urgently Reduce Stock',
//     value: 'Urgently Reduce Stock',
//     checked: false,
//     color: 'rgba(255, 194, 85, 0.4)',
//   },
//   {
//     id: 'Overstocked',
//     value: 'Overstocked',
//     checked: false,
//     color: 'rgba(234, 231, 7,0.4)',
//   },
//   {
//     id: 'Sufficient Stock',
//     value: 'Sufficient Stock',
//     checked: false,
//     color: 'rgba(0, 156, 162, 0.4)',
//   },
//   {
//     id: 'Running Low',
//     value: 'Running Low',
//     checked: false,
//     color: 'rgba(255, 105, 119, 0.4)',
//   },
// ]

export const RiskFilterStatuses = [
  {
    id: 'Select All',
    value: 'Select All',
    checked: false,
    color: '#ffffff',
  },
  {
    id: 'No Action Required',
    value: 'No Action Required',
    checked: false,
    color: '#ffffff',
  },
  {
    id: 'Dead Stock',
    value: 'Dead Stock',
    checked: false,
    color: 'rgba(74, 202, 255, 0.4)',
  },
  {
    id: 'Overstocked',
    value: 'Overstocked',
    checked: false,
    color: 'rgba(234, 231, 7,0.4)',
  },
  {
    id: 'Expiry At Risk',
    value: 'Expiry At Risk',
    checked: false,
    color: 'rgba(255, 194, 85, 0.4)',
  },
  {
    id: 'Out Of Date',
    value: 'Out Of Date',
    checked: false,
    color: 'rgba(255, 105, 91, 0.4)',
  },
]
